var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"px-2",attrs:{"label":"","dark":"","color":"#3d70b2"}},[_vm._v(" Repeat "+_vm._s(_vm.formattedReps)+"x ")])
}
var staticRenderFns = []

export { render, staticRenderFns }